<template>
	<li class="list-group-item px-0 py-3 lh-sm hstack gap-2">
		<div class="hstack gap-2 align-items-start flex-fill">
			<CommonImageSquare :src="product.image_url" size="lg" rounded="3" :border="true" class="mx-auto" />
			<div class="vstack">
				<a href="javascript:void(0);" class="fw-bold link-dark stretched-link" @click="select">{{ product.name }}</a>
				<div class="fw-bold text-muted">{{ vueNumberFormat(product.amount, { suffix: ` ${product.currency}`, precision: 2 }) }}</div>
				<small class="text-muted" v-if="product.extras?.code"><b>Código:</b> {{ product.extras.code }}</small>
				<small class="text-muted" v-if="variant?.attributes?.color"><b>Color:</b> {{ variant.attributes.color }}</small>
				<small class="text-muted" v-if="variant?.attributes?.size"><b>Medida:</b> {{ variant.attributes.size }}</small>
			</div>
		</div>
		<i class="bi bi-chevron-right text-xl"></i>
	</li>
</template>

<script>
	import _ from 'lodash';

	export default {
		emits: ['select'],
		props: {
			product: Object,
			variant: Object
		},
		setup(props, { emit }) {
			const select = () => {
				let data = _.pick(_.cloneDeep(props.product), ['id', 'name', 'currency', 'amount', 'amount_sale', 'image_url', 'extras']);
				data.pivot = {
					attributes: props.variant.attributes,
					quantity: 1,
					stock: props.variant.stock
				};

				emit('select', data);
			}

			return { select };
		}
	}
</script>